import {CarouselSlide} from "../components/carousel_slide";
import {CarouselPagination} from "../components/carousel_pagination";
import {CarouselControls} from "../components/carousel_controls";

export function getCarouselSlides(carousel) {
    const slideElements = carousel.element.querySelectorAll(carousel.config.slideSelector);
    let slides = [];
    
    slideElements.forEach((slideElement, index) => {
        const slideConfig = carousel.slideConfigs ? carousel.slideConfigs[index] : null;
        slides.push(new CarouselSlide(slideElement, carousel, slideConfig));
    });
    
    return slides;
}

export function getCarouselPagination(carousel) {
    const paginationElement = carousel.element.querySelector(carousel.config.paginationSelector);
    if (!paginationElement) return null;
    
    return new CarouselPagination(paginationElement, carousel);
}

export function getCarouselControls(carousel) {
    const controlsElement = carousel.element.querySelector(carousel.config.controlsSelector);
    if (!controlsElement) return null;
    
    return new CarouselControls(controlsElement, carousel);
}